<template>
  <div class="main">
    <div class="content" :style='{ backgroundImage: `url("${imgSrc}")`}'>
      <div class="contentLeft">
        <transition name="fade">
          <img v-if="page_mounted && isRoot" :src="require('./img/login-logo.png')"/>
        </transition>
      </div>
      <transition name="left-fade">
        <div class="loginStyleForm" v-show="page_mounted">
          <span class="title" v-if="false"> 
            D<span class="highlight">V</span>PM </span>
          <div class="title" v-else>
            <img :src="require('./img/login-logo.png')"/>
          </div>
          <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="rules"
            label-position="left"
            label-width="0px"
            class="demo-ruleForm loginPage"
          >
            <el-form-item prop="username">
              <el-input
                v-model="loginForm.username"
                type="text"
                size="small"
                auto-complete="off"
                placeholder="账号"
                style="width: 358px"
                @keydown.native="keydown($event)"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password" style="margin-top: 58px">
              <el-input
                v-model="loginForm.password"
                :type="passwordType"
                autocomplete="off"
                size="small"
                placeholder="密码"
                style="width: 358px"
                class="passwordStyle"
                @keydown.native="keydown($event)"
                @input="changeInputValue1(loginForm.password)"
              >
                <p
                  v-if="passwordType == 'text' && loginForm.password"
                  slot="suffix"
                  class="bukejin"
                  @click="showPwd"
                ></p>
                <p
                  v-if="passwordType == 'password' && loginForm.password"
                  slot="suffix"
                  class="nobukejin"
                  @click="showPwd"
                ></p>
              </el-input>
            </el-form-item>
            <el-form-item style="margin-top: 58px">
              <el-button
                class="handleLoginStyle"
                :loading="logining"
                plain
                @click="handleLogin('loginForm')"
              >
                登录
              </el-button>
            </el-form-item>
            <div class="loginFormFoot">
              <p style="margin-top:15px" @click="goregister">
                <!-- <span>立即注册</span> -->
              </p>
              <p style="margin-top: 12px" @click="gppassword">
                <span>忘记密码?</span>
              </p>
            </div>
          </el-form>
          <div class="form-footer">
            <span> 法律声明 隐私政策声明</span>
            <div class="right">
              <span>上海联创设计集团有限公司所有</span>
              <a href="https://beian.miit.gov.cn" target="_blank" style="color: #a6a6a6; text-decoration: none; cursor: pointer;">ICP备案/许可证号: 沪ICP备05008806号-4</a>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- 插件端下载 -->
    <el-dialog
      v-dialogDrag
      :visible.sync="downloadDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="客户端下载"
      width="500px"
    >
      <div class="downunit">
        <img :src="$appLogo" :alt="$appTitle" class="downunit-bottom" />
        <el-button
          type="primary"
          size="small"
          class="downunit-bottom"
          @click="downPlugBtn"
        >
          REVIT插件下载
        </el-button>
        <span class="downunit-bottom">更新时间：{{ plugForm.createTime }}</span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import loginService from "@/xgzdService/login-service";
import enterpriseService from "@/CommonDP/service/enterprise-service";
// 开发模式背景走本地 生产模式走cdn
const imgSrc = process.env.NODE_ENV === 'development' ? require('./img/login-bg.png'): 'cdn/bg'
export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
      },
      imgSrc,
      logining: false,
      rules: {
        username: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      passwordType: "password",
      erpriseList: [],
      imgs: [
        require("./img/pic2.png"),
        require("./img/pic1.png"),
        require("./img/pic3.png"),
      ],
      currImgs: [require("./img/pic2.png")],
      index: 0,
      downloadDialog: false,
      plugForm: {
        createTime: "",
        filePath: "",
      },
      page_mounted: false,
      isRoot: false
    };
  },
  mounted() {
    this.startChange();
    this.page_mounted = true
    this.isRoot = window.location.pathname == '/'
  },
  methods: {
    //帮助手册提示
    manualHelpBtn() {
      this.$message.warning("请登录后再进行帮助手册的查看与下载操作");
    },
    async plugBtn() {
      this.downloadDialog = true;
      const res = await enterpriseService.getPlugList();
      if (res.data && res.data.length > 0) {
        const a = res.data[0].createTime.split(" ")[0];
        this.plugForm.createTime = a.replace(/-/g, "/");
        this.plugForm.filePath = res.data[0].filePath;
      }
    },
    downPlugBtn() {
      if (this.plugForm.filePath) {
        const fileUrl = enterpriseService.downloadUrlone(
          this.plugForm.filePath
        );
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.style.height = 0;
        iframe.src = fileUrl;
        document.body.appendChild(iframe);
        setTimeout(() => {
          iframe.remove();
        }, 5 * 60 * 1000);
      } else {
        this.$message.warning("暂无文件");
      }
    },
    startChange() {
      var _this = this;
      setInterval(() => {
        if (_this.index < _this.imgs.length - 1) {
          _this.index++;
        } else {
          _this.index = 0;
        }
        _this.currImgs.splice(0, 1, _this.imgs[_this.index]);
      }, 5000);
    },
    changeInputValue1() {
      if (!this.loginForm.password) {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
    },
    keydown(event) {
      if (event.keyCode === 32) {
        event.returnValue = false;
      }
    },
    async handleLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.logining = true;
          const data = new FormData();
          data.append("username", this.loginForm.username);
          data.append("password", this.loginForm.password);
          loginService
            .loginByUsername(data)
            .then((res) => {
              // var token = "Bearer " + res.data.token;
              this.$store.dispatch("setUserInfo", res.data);
              this.logining = false;
              // 被别人邀请但是没有登录
              if (this.$route.query.code) {
                var code = this.$route.query.code;
                this.$router.replace({
                  path: "/joinEnterprise",
                  query: { code: code },
                });
              } else {
                // 直接登录
                enterpriseService.usergetEnterpriseList().then((res) => {
                  if (res.result === "0") {
                    this.erpriseList = res.data;
                    var ll = this.erpriseList.length;
                    if (ll) {
                      // 有一个企业
                      if (ll === 1) {
                        // 如果只有一个企业 不用判断用哪一个 直接用这一个
                        // status 企业的状态 0 审核中 1 通过 2 驳回 3解散 4禁用
                        // 先判断企业的状态 如果企业被驳回了 跳到驳回重新申请页面
                        // 如果企业通过了(不管是我创建的企业 还是我加入的企业joinStatus都是1)判断企业有没有启用/禁用等
                        // 如果企业审批中 提示我创建的企业在审核中
                        if (this.erpriseList[0].status === 0) {
                          // 审核中 创建的
                          const { href } = this.$router.resolve({
                            path: "/noenterprise",
                            query: {
                              showtype: 1,
                              name: this.erpriseList[0].enterpriseName,
                            },
                          });
                          window.open(href, "_blank");
                        } else if (this.erpriseList[0].status === 1) {
                          // 通过 企业通过的情况下 企业创建人 一定是加入的状态   后来加入的人 才会走到审核中状态里
                          // 加入的人 没有驳回的状态 发信息通知 企业列表里 没有加入的人 是驳回的状态
                          if (this.erpriseList[0].joinStatus === 1) {
                            // 启用
                            if (this.erpriseList[0].isEnabled === 1) {
                              enterpriseService
                                .userselectEnterprise(
                                  this.erpriseList[0].enterpriseId
                                )
                                .then((res) => {
                                  if (res.result === "0") {
                                    this.$store.dispatch("setUnauthorized", 1);
                                    this.$store.dispatch("setEnterpriseId",this.erpriseList[0].enterpriseId);
                                    this.$store.dispatch("setIsTrial",this.erpriseList[0].isTrial);
                                    this.$router.push("/mainMg"); // 记录id
                                  }
                                })
                                .catch(() => {});
                            } else {
                              // 禁用(我被企业禁用)
                              const { href } = this.$router.resolve({
                                path: "/noenterprise",
                                query: {
                                  showtype: 2,
                                  name: this.erpriseList[0].enterpriseName,
                                },
                              });
                              window.open(href, "_blank");
                            }
                          } else if (this.erpriseList[0].joinStatus === 0) {
                            // 审核中 加入的 一定是加入的
                            const { href } = this.$router.resolve({
                              path: "/noenterprise",
                              query: {
                                showtype: 3,
                                name: this.erpriseList[0].enterpriseName,
                              },
                            });
                            window.open(href, "_blank");
                          }
                        } else if (this.erpriseList[0].status === 2) {
                          // 驳回
                          this.$router.replace({
                            path: "/creationcomplete",
                            query: { id: this.erpriseList[0].enterpriseId },
                          });
                        } else if (this.erpriseList[0].status === 4) {
                          // 禁用(企业被禁用)
                          const { href } = this.$router.resolve({
                            path: "/noenterprise",
                            query: {
                              showtype: 4,
                              name: this.erpriseList[0].enterpriseName,
                            },
                          });
                          window.open(href, "_blank");
                        }
                      } else {
                        // 选择企业
                        const erpriseLists = this.erpriseList.filter(
                          (item) => item.isSelect === 1
                        );
                        // console.log(erpriseLists[0],'officersIds');
                        // 有最后一个登录的企业 判断最后一个企业是不是能用的 最后一个登录的企业 一定是审核通过的 只有可能是审核通过以后被解散的 企业被禁用的 或者这个人被禁用了
                        // 被解散的企业不会再列表里
                        if (erpriseLists.length) {
                          if (erpriseLists[0].status === 4) {
                            const { href } = this.$router.resolve({
                              path: "/noenterprise",
                              query: {
                                showtype: 4,
                                name: erpriseLists[0].enterpriseName,
                              },
                            });
                            window.open(href, "_blank");
                          } else if (
                            erpriseLists[0].status === 1 &&
                            erpriseLists[0].isEnabled === 0
                          ) {
                            // 禁用(我被企业禁用)
                            const { href } = this.$router.resolve({
                              path: "/noenterprise",
                              query: {
                                showtype: 2,
                                name: erpriseLists[0].enterpriseName,
                              },
                            });
                            window.open(href, "_blank");
                          } else {
                            this.$store.dispatch(
                              "setEnterpriseId",
                              erpriseLists[0].enterpriseId
                            );
                            this.$store.dispatch(
                              "setIsTrial",
                              erpriseLists[0].isTrial
                            );
                            this.$router.push("/mainMg"); // 记录id
                          }
                        } else {
                          // 没有最后登录的企业
                          this.$router.push("/changeenterprise");
                        }
                      }
                    } else {
                      // 没有企业 跳转 创建/加入企业
                      this.$router.replace({
                        path: "/enterprisepage",
                        query: { pagetype: "0" },
                      });
                    }
                  }
                });
              }
            })
            .catch(() => {
              this.logining = false;
            });
        } else {
          return false;
        }
      });
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
    },
    goregister() {
      localStorage.setItem("stepsIndex", 0);
      if (this.$route.query.code) {
        var code = this.$route.query.code;
        this.$router.replace({ path: "/register", query: { code: code } });
      } else {
        this.$router.push("/register");
      }
    },
    gppassword() {
      this.$message.warning('请联系管理员重置密码')
      return
      localStorage.setItem("stepsIndex2", 0);
      if (this.$route.query.code) {
        var code = this.$route.query.code;
        this.$router.replace({ path: "/password", query: { code: code } });
      } else {
        this.$router.push("/password");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 2s;
  position: relative;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(90px);
}

.left-fade-enter-active,
.left-fade-leave-active {
  transition: all 2s;
  position: relative;
}
.left-fade-enter,
.left-fade-leave-to {
  transform: translate(400px,-50%) !important;
}
.main {
  width: 100%;
  height: 100%;
  min-height: 700px;
  min-width: 800px;
  overflow: hidden;
  .content {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 25px;
    .contentLeft {
      width: 700px;
      height: 435px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-left: 150px;
      overflow: hidden;
      position: relative;
      img {
        margin-bottom: 100px;
      }
      /deep/ .el-carousel__indicators--horizontal {
        display: none;
      }
      /deep/ .el-carousel__arrow--left {
        display: none;
      }
      /deep/ .el-carousel__arrow--right {
        display: none;
      }
      .flip-list-enter-active,
      .flip-list-leave-active {
        transition: all 3s;
      }
      .flip-list-enter,
      .flip-list-leave-active {
        opacity: 0;
      }
      li {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .loginStyleForm {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 10px;
      width: 420px;
      height: calc(100% - 10px);
      background: #ffffff66;
      // backdrop-filter: blur(6px);
      box-shadow: 0px 0px 4px rgba(55, 106, 227, 0.1);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      gap: 60px;
      ::v-deep .el-input__inner {
        background-color: #fff!important;
        border: 0px solid #b6b6b6 !important;
        border-radius: 8px !important;
        &::placeholder {
          color: #b6b6b6 !important;
          letter-spacing: 5px;
          background-color: #fff !important;
          text-align: center;
        }
      }
      .erweima {
        position: absolute;
        top: 0;
        right: 0;
        user-select: none;
      }
      .title {
        margin-top: 120px;
        width: 100%;
        text-align: center;
        user-select: none;
        font-size: 28px;
        line-height: 24px;
        padding-top: 90px;
        letter-spacing: 2px;
        font-weight: bold;
        .highlight {
          font-weight: inherit;
          font-size: inherit;
          color: #2572aa;
        }
      }
      div.title {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          height: 50px;
        }
      }
      .loginPage {
        width: 100%;
        padding-bottom: 37px;
        display: flex;
        flex-direction: column;
        align-items: center;
        $input_height: 36px;
        /deep/ .el-form-item {
          margin-bottom: 0px;
          .el-input__inner {
            background: #e8f0fe;
            border-color: #fff;
            border-radius: 2px;
            color: #6681a0;
            height: $input_height;
          }
          .el-input__inner:focus {
            border-color: #fff;
          }
          .el-button--primary {
            background: #72a6fe !important;
          }
          .el-button--primary:hover {
            background: #5584ff !important;
          }
          .el-form-item__content {
            line-height: 0px;
          }
        }
        .passwordStyle {
          p {
            width: 20px;
            height: 16px;
            background-position: center center;
            margin-top: 15px;
            margin-right: 15px;
            background-size: 14px;
          }
        }
        @mixin center {
          display: flex;
          align-items: center;
          height: #{$input_height} !important;
          width: 20px;
          margin: 0px !important;
          justify-content: center;
          cursor: pointer;
        }
        .bukejin {
          background: url("./img/openEye.png") no-repeat;
          @include center;
        }
        .nobukejin {
          background: url("./img/closeEye.png") no-repeat;
          @include center;
        }
        .handleLoginStyle {
          width: 358px !important;
          height: 36px !important;
          border-radius: 8px !important;
          border: 0px solid #b6b6b6 !important;
          color: #2572aa;
        }
      }
      label.el-checkbox.rememberme {
        margin: 8px 0px 26px 279px;
      }
      .loginFormFoot {
        width: 358px;
        height: 42px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        span {
          font-size: 14px;
          color: #2572aa;
          cursor: pointer;
        }
      }
    }
    .form-footer {
      position: absolute;
      bottom: 10px;
      left: 0;
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      padding: 10px;
      span {
        color:#a6a6a6; 
      }
      .right {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 3px;
      }
    }
  }
  .footer {
    width: 100%;
    height: 52px;
    padding: 0 25px;
    display: flex;
    flex-direction: row;
    align-items: center;
    a,
    span {
      color: currentColor;
    }
    a {
      margin-right: 5px;
    }
    img {
      margin-left: 5px;
      margin-right: 5px;
      width: 15px;
      height: 15px;
      user-select: none;
    }
    .footerright {
      margin-left: auto;
      span {
        user-select: none;
      }
      .nbsp {
        margin-left: 30px;
        margin-right: 30px;
      }
    }
  }
}
.downunit {
  display: flex;
  flex-direction: column;
  align-items: center;
  .downunit-bottom {
    margin-bottom: 10px;
    width: 50%;
  }
  img.downunit-bottom {
    filter: brightness(0);
  }
  .downunit-font {
    font-weight: 600;
    font-size: 20px;
    letter-spacing: 2px;
    text-align: center;
  }
}
</style>
